/* eslint-disable no-unused-vars */
/**
 * @module RecommendedArticleCard
 */
import React from 'react';
import sample from 'lodash/sample';
import { FALLBACK_IMAGE } from '../../helpers/constants';
import LCImage from '../LCImage/LCImage';
import Tags from '../Tags/Tags';
import './RecommendedArticles.scss';

/**
 * Represents a card container element to hold a recommended article.
 *
 * @param {object} props - The component props object.
 * @param {Array} props.articleData - Object of article data.
 * @param {Function} props.onClick - Handler function for link click event.
 *
 * @returns {React.ReactElement} The RecommendedArticles component.
 */
function RecommendedArticleCard({ articleData, onClick }) {
  const [randomTag, setRandomTag] = React.useState(
    articleData['mgnl:tags']?.length ? [sample(articleData['mgnl:tags'])] : [],
  );
  const [imageSrc, setImageSrc] = React.useState(
    articleData.featuredImage?.['@link'] ||
      articleData.featuredImage ||
      FALLBACK_IMAGE,
  );

  React.useEffect(() => {
    if (articleData && (!randomTag || randomTag.length)) {
      setRandomTag(
        /* istanbul ignore next */
        articleData['mgnl:tags']?.length
          ? [sample(articleData['mgnl:tags'])]
          : [],
      );
      setImageSrc(
        articleData.featuredImage?.['@link'] ||
          articleData.featuredImage ||
          FALLBACK_IMAGE,
      );
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [articleData]);

  return (
    <div className="recommended-article-card" key={articleData['@id']}>
      <div className="image-wrap">
        <LCImage
          alt={'Article image'}
          className="image"
          src={imageSrc}
          width={300}
        />
      </div>
      <div className="text-wrap">
        <Tags tags={randomTag} />
        <a
          className="article-link"
          href={`/${articleData['@name']}`}
          onClick={onClick}
        >
          <h4>{articleData.title}</h4>
        </a>
      </div>
    </div>
  );
}

export default RecommendedArticleCard;
